import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducers/rootReducer';

/**
 * Creates an internal redux store for handling Customer Information
 * @param {*} preloadedState
 */
function createStore(preloadedState = {}) {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: { name: 'Customer Information | Virgin Money UK' }
  });

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('reducers/rootReducer', () => store.replaceReducer(rootReducer));
    }
  }
  return store;
}

export { createStore };
